export default __webpack_public_path__ + "static/media/SportsTonic.743e5d79eacb6f579530c181af055055.webp";